import { render, staticRenderFns } from "./connect-complete.page.vue?vue&type=template&id=537934fa&scoped=true&"
import script from "./connect-complete.page.vue?vue&type=script&lang=js&"
export * from "./connect-complete.page.vue?vue&type=script&lang=js&"
import style0 from "./connect-complete.page.vue?vue&type=style&index=0&id=537934fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537934fa",
  null
  
)

export default component.exports